'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keymap = _interopDefault(require('../keymap/index.js'));
var index_js = require('../utils/index.js');
require('../cursor/index.js');
require('prosemirror-transform');
var prosemirrorModel = require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');
var prosemirrorView = require('prosemirror-view');
var preact = require('preact');
var index_js$2 = require('../components/index.js');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

const noteSchema = {
  nodes: {
    note: {
      group: 'block',
      content: 'note_title note_content',
      isolating: true,
      allowGapCursor: true,
      insertBlock: true,
      dragBlock: true,
      braceWidth: 300,
      attrs: {
        type: {
          default: 'note'
        },
        hiddenTitle: {
          default: true
        },
        dataDiffId: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'div[class~="ct-note"]',
        getAttrs: dom => ({
          type: dom.getAttribute('data-type'),
          hiddenTitle: dom.classList.contains('hidden-title'),
          dataDiffId: dom.getAttribute('data-diff-id')
        })
      }],

      toDOM(node) {
        const {
          attrs: {
            type,
            hiddenTitle,
            dataDiffId
          }
        } = node;
        const nodeAttrs = {
          class: `ct-note${hiddenTitle ? ' hidden-title' : ''}`,
          'data-type': type,
          'data-diff-id': dataDiffId || `ct-diff-id-${uuid()}`
        };
        return ['div', nodeAttrs, 0];
      }

    },
    note_title: {
      content: 'text*',
      alignBlock: true,
      attrs: {
        align: {
          default: 'left'
        }
      },
      parseDOM: [{
        tag: 'div[class~="ct-note-title"]',
        getAttrs: dom => ({
          align: dom.style.textAlign
        })
      }],

      toDOM(node) {
        const {
          align
        } = node.attrs;
        const attrs = {
          class: 'ct-note-title'
        };

        if (align && align !== 'left') {
          attrs.style = `text-align: ${align};`;
        }

        return ['div', attrs, ['span', {
          class: 'ct-note-title-text'
        }, 0]];
      }

    },
    note_content: {
      content: 'block+',
      attrs: {},
      parseDOM: [{
        tag: 'div[class~="ct-note-content"]'
      }],

      toDOM() {
        const nodeAttrs = {
          class: 'ct-note-content'
        };
        return ['div', nodeAttrs, 0];
      }

    }
  }
};

function insert(store) {
  return function (type) {
    return function (state, dispatch, view, trigger) {
      const {
        schema,
        tr,
        selection
      } = state;
      const {
        from
      } = selection;
      const {
        note,
        note_title,
        note_content
      } = schema.nodes;
      const titleNode = note_title.createAndFill();
      const contentNode = note_content.createAndFill();
      const noteNode = note.create({
        type
      }, prosemirrorModel.Fragment.from([titleNode, contentNode]));
      const {
        transaction
      } = index_js.insertBlock(state, noteNode);

      if (!transaction) {
        return false;
      }

      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1));
      dispatch(transaction.scrollIntoView());
      view.focus();
      return true; // let noteDOM;
      // noteDOM = view.docView.domFromPos(selection.from).node;
      // if (!noteDOM.classList.contains("ct-note")) {
      //   noteDOM = view.docView.domFromPos(selection.from + 1).node;
      // }
      // if (!noteDOM.classList.contains("ct-note")) {
      //   noteDOM = view.docView.domFromPos(selection.from + 2).node;
      // }
      // store.showPopover(noteDOM);
      // if (typeof trigger === "function") { trigger("afterInsert", { draggable: true, braceWidth: 300 }); }
    };
  };
}
function setAttrs(attrs) {
  return function (state, dispatch) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      $from
    } = selection;
    const {
      note
    } = schema.nodes;

    const assert = node => node.type === note;

    const foundNode = index_js.findParentNode($from.path, assert);

    if (!foundNode) {
      return false;
    }

    const oldAttrs = foundNode.node.attrs;
    dispatch(tr.setNodeMarkup(foundNode.pos, null, objectSpread({}, oldAttrs, attrs)));
    return true;
  };
}

// const getNoteDOM = (view, nodePos) => {
//   let dom = view.docView.domFromPos(nodePos + 1).node;
//   if (dom && !dom.classList.contains("ct-note")) { dom = dom.parentNode; }
//   return dom;
// };

function createPlugin(store) {
  // const togglePopover = (e) => {
  //   const noteDOM = findParentDOM(e.target, assert);
  //   noteDOM ? store.showPopover(noteDOM) : store.hidePopover();
  // };
  const pluginKey = new prosemirrorState.PluginKey("note");
  const plugin = new prosemirrorState.Plugin({
    key: pluginKey,
    props: {
      decorations: state => {
        const {
          selection,
          schema,
          doc
        } = state;
        const {
          $from
        } = selection;
        const {
          note
        } = schema.nodes;
        const foundNode = index_js.findParentNode($from.path, node => node.type === note);

        if (foundNode) {
          const deco = prosemirrorView.Decoration.node(foundNode.pos, foundNode.node.nodeSize + foundNode.pos, {
            nodeName: "div",
            class: "ct-note-selected"
          });
          return prosemirrorView.DecorationSet.create(doc, [deco]);
        }
      },
      handleDrop: (view, event, slice, moved) => {
        try {
          const {
            status
          } = view.state.schema.nodes;

          if (event.target.classList.contains("ct-note")) {
            return true;
          }

          if (event.target.closest(".ct-note-title")) {
            const content = slice.content.content;

            if (content.length > 1) {
              return true;
            }

            if (content[0].isTextblock && content[0].content.content.length === 1) {
              return false;
            }

            if (content[0].isBlock || content[0].type === status) {
              return true;
            }
          }
        } catch (err) {}
      },
      // handleClickOn: (view, pos, node, nodePos, e) => {
      //   if (node.type.name === "note") {
      //     const dom = getNoteDOM(view, nodePos);
      //     store.showPopover({
      //       dom,
      //       attrs: node.attrs,
      //       pos: nodePos,
      //     });
      //   } else {
      //     store.hidePopover();
      //   }
      //   return false;
      // },
      handleDOMEvents: {// drop: () => {
        //   store.hidePopover();
        // },
        // keyup: (view) => {
        //   const { schema, selection } = view.state;
        //   const { $from } = selection;
        //   const note = schema.nodes.note;
        //   const foundNode = findParentNode($from.path, node => node.type === note);
        //   if (foundNode) {
        //     const noteDOM = getNoteDOM(view, foundNode.pos);
        //     store.showPopover({ dom: noteDOM, pos: foundNode.pos, attrs: foundNode.attrs });
        //   } else {
        //     store.hidePopover();
        //   }
        //   if (view.lastKeyCode === 8) { return false; }
        // },
        // contextmenu: (view, e) => {
        //   togglePopover(e);
        // },
      }
    },
    view: view => new index_js.Popover({
      view,
      store,
      className: "ct-note-popover"
    })
  });
  return plugin;
}

const handleBackspace = index_js.handleBackspaceCreator('note', 'note_title', 'note_content');
const handleDelete = index_js.handleDeleteCreator('note', 'note_title', 'note_content');
const handleTab = index_js.handleTabCreator('note', 'note_title', 'note_content');
const handleEnter = index_js.handleEnterCreator('note', 'note_title', 'note_content');

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-note-popover{z-index:9}.ct-note-popover .ct-note-editor{width:72px;height:34px;line-height:17px;padding:2px 8px;font-size:13px;color:#333;cursor:pointer}";
styleInject(css);

/** @jsx h */

class NoteEditor extends preact.Component {
  constructor(...args) {
    super(...args);

    this.handleClick = () => {
      this.props.toggleTitle();
    };
  }

  render() {
    const {
      hiddenTitle
    } = this.props;
    return preact.h("div", {
      className: "ct-note-editor"
    }, preact.h(index_js$2.CheckBox, {
      checked: !hiddenTitle,
      onClick: this.handleClick
    }, "\u6807\u9898"));
  }

}

/** @jsx h */

class NoteStore {
  constructor() {
    this.pluginName = "note";

    this.showPopover = node => {
      this.hidePopover();

      if (node) {
        this.node = node;
        const {
          dom,
          attrs
        } = node;
        this.ctPopover.show({
          dom,
          content: this.getToolbar(attrs.hiddenTitle)
        });
      } // if (this.popover) {
      //   super.showPopover(domNode)
      //   const domRect = domNode.getBoundingClientRect()
      //   this.popover.style.display = 'block'
      //   this.popover.style.left = `${domRect.left}px`
      //   this.popover.style.top = `${domRect.top - 30}px`
      //   this.hiddenTitle = domNode.classList.contains('hidden-title')
      //   this.renderEditor()
      // }

    };

    this.updateAttrs = data => {
      if (!this.node) {
        return;
      }

      const {
        state,
        dispatch
      } = this.editor.view;
      const {
        tr,
        schema
      } = state;
      const nodeType = schema.nodes.note;

      const attrs = objectSpread({}, this.node.attrs, data);

      const {
        pos
      } = this.node;
      dispatch(tr.setNodeMarkup(pos, nodeType, attrs));
      const dom = this.editor.view.nodeDOM(pos);
      return {
        dom,
        pos,
        attrs
      };
    };

    this.hidePopover = () => {
      this.ctPopover.hide();
    };

    this.toggleTitle = () => {
      if (!this.node) {
        return;
      }

      const node = this.updateAttrs({
        hiddenTitle: !this.node.attrs.hiddenTitle
      }); // this.view.focus()
      // this.modules.table && this.modules.table.store.reShowPopover()

      this.showPopover(node);
    };

    this.getToolbar = hiddenTitle => preact.h(NoteEditor, {
      hiddenTitle: hiddenTitle,
      toggleTitle: this.toggleTitle
    });
  }

  init(editor) {
    this.editor = editor;
    this.view = editor.view;
  }

}

const noteToView = ({
  bodyWrapper
}) => {
  const noteNodes = bodyWrapper.querySelectorAll('.ct-note');
  noteNodes.forEach(node => {
    Array.from(node.children).forEach(child => {
      if (child.innerHTML.trim() === '') {
        node.removeChild(child);
      }
    });
  });
};

var css$1 = ".ct-note-selected .ct-note{border-color:#fdc446}.ct-note-selected .ct-note[data-type=info]{border-color:#23bdd9}.ct-note-selected .ct-note[data-type=tip]{border-color:#53752d}.ct-note-selected .ct-note[data-type=warning]{border-color:#e75252}.ct-note{min-width:265px;min-height:42px;margin:8px 0;border:1px solid transparent;border-radius:4px;background-color:#fffbe6}.ct-note.ProseMirror-selectednode{border-color:#fdc446}.ct-note[data-type=info]{background-color:#e6ffff}.ct-note[data-type=info].ProseMirror-selectednode{border-color:#23bdd9}.ct-note[data-type=tip]{background-color:#f6ffed}.ct-note[data-type=tip].ProseMirror-selectednode{border-color:#53752d}.ct-note[data-type=warning]{background-color:#fff1f0}.ct-note[data-type=warning].ProseMirror-selectednode{border-color:#e75252}.ct-note.ProseMirror-selectednode{position:relative}.ct-note.ProseMirror-selectednode:after{z-index:2;position:absolute;content:\"\";left:-1px;right:-1px;top:-1px;bottom:-1px;background-color:#23bdd9;opacity:.2;pointer-events:none}.hidden-title{background:#fffbe6 url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23FDC446'/%3E%3C/svg%3E\") no-repeat 10px 10px}.hidden-title>.ct-note-title{display:none}.hidden-title[data-type=info]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 .448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z' fill='%233d91f2'/%3E%3C/svg%3E\")}.hidden-title[data-type=tip]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M550.4 573.76v27.84a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-.96c.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8.96c-.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048V720a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z' fill='%2370B123'/%3E%3C/svg%3E\")}.hidden-title[data-type=warning]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23F05E50'/%3E%3C/svg%3E\")}.ct-note-title{min-height:24px;padding:8px 0;font-size:14px;font-weight:700;color:#333;line-height:24px}.ct-note-title>.ct-note-title-text{position:relative;display:inline-block;min-height:24px;padding-left:36px;color:#333;line-height:24px;font-family:PingFangSC-Medium;font-size:13px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23FDC446'/%3E%3C/svg%3E\") no-repeat;background-position:10px 3px}[data-type=info]>.ct-note-title>.ct-note-title-text{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 .448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z' fill='%233d91f2'/%3E%3C/svg%3E\")}[data-type=tip]>.ct-note-title>.ct-note-title-text{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M550.4 573.76v27.84a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-.96c.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8.96c-.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048V720a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z' fill='%2370B123'/%3E%3C/svg%3E\")}[data-type=warning]>.ct-note-title>.ct-note-title-text{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23F05E50'/%3E%3C/svg%3E\")}.ct-note-content{padding:0 8px 0 36px;overflow:hidden}";
styleInject(css$1);

class NoteModule {
  constructor() {
    this.name = 'note';
    this.store = new NoteStore();
    this.schema = noteSchema;
    this.commands = {
      insert: insert(this.store),
      setAttrs: attrs => setAttrs(attrs)
    };
    this.plugins = [createPlugin(this.store), keymap({
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      Delete: handleDelete,
      'Mod-Delete': handleDelete,
      Tab: handleTab,
      Enter: handleEnter
    })];
  }

  init(moduleManager) {
    this.store.init(moduleManager);
  }

}
NoteModule.moduleName = 'note';

exports.NoteModule = NoteModule;
exports.noteToView = noteToView;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/note/index.js